module.exports = __webpack_public_path__ + "static/media/notFound.6abb6c1a.png";